import React, { useRef } from 'react';
import { Badge, SlotHost, useElementEmpty } from '@datanomik/core-ui';

export interface ShellPageTitleProps {
  title?: React.ReactNode;
  isBeta?: boolean;
}

export const ShellPageTitle: React.FC<ShellPageTitleProps> = ({ title, isBeta }) => {
  const slotRef = useRef<HTMLDivElement>(null);
  const slotEmpty = useElementEmpty(slotRef);

  return (
    <div className="flex min-w-0 items-center gap-2">
      {slotEmpty && title ? (
        <h1 className="text-foreground truncate font-[Inter_Display,Inter,sans-serif] text-base leading-6 font-semibold">
          {title}
        </h1>
      ) : null}
      {slotEmpty && isBeta ? <Badge tone="warning">Beta</Badge> : null}
      <div ref={slotRef} className="flex min-w-0 items-center">
        <SlotHost name="top-left" className="min-w-0 gap-2" />
      </div>
    </div>
  );
};

export default ShellPageTitle;
